// Pure watch-streak math, kept free of the Supabase client so it's unit-testable
// under `node --test` (streak.js imports the DB client, which the test runner
// can't resolve). streak.js fetches the rows, then hands the day-key set here.
import { prevDay } from './datetime.js'

// Given the set of calendar-day keys on which the user had activity and today's
// key, return the live streak (counting back from today, or yesterday if today
// isn't active yet), the best-ever run, and whether today is already active.
// Day keys are 'YYYY-MM-DD' in the user's zone; accepts a Set or an array.
export function streakFromDays(days, today) {
  const set = days instanceof Set ? days : new Set(days)
  if (set.size === 0) return { current: 0, best: 0, activeToday: false }

  const yesterday = prevDay(today)
  let current = 0
  let cursor = set.has(today) ? today : (set.has(yesterday) ? yesterday : null)
  while (cursor && set.has(cursor)) {
    current++
    cursor = prevDay(cursor)
  }

  const sorted = [...set].sort()
  let best = 0, run = 1
  for (let i = 1; i < sorted.length; i++) {
    const prev = new Date(sorted[i - 1]).getTime()
    const curr = new Date(sorted[i]).getTime()
    if (curr - prev <= 86400000 * 1.5) run++
    else { best = Math.max(best, run); run = 1 }
  }
  best = Math.max(best, run, current)

  // activeToday lets callers show an "at risk — keep it alive tonight" stake.
  return { current, best, activeToday: set.has(today) }
}
